type Observation = { axis: string; points: number[]; origin: number[]; normal: number[]; visible: boolean };
const readers = new Map<string, () => Observation>();
export function observeContour(id: string, read: () => Observation) { readers.set(id, read); return () => readers.delete(id); }
export function sceneContours() { return [...readers.values()].map(read => read()); }
